import { useEffect } from 'react'
import styled from 'styled-components'
import { View, TouchableOpacity, ImageBackground, Text } from 'react-native'
import { Heading, Row } from 'native-base'
import { useRecoilState } from 'recoil'
import { allPhotosState, cameraState, categoryIconState, modalState, imageState, selectedCategoryTitleState, selectedCategoryValueState, categoryPointsState, submittedPhotoState } from '../../state/atoms'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import * as ImagePicker from 'expo-image-picker'

const AddPhotoContainer = styled(View)`
    display: flex;
    align-items: center;
    justify-content: center;
`

const PhotoBox = styled(TouchableOpacity)`
    border: 1px solid grey;
    width: 100px;
    height: 100px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin: 10px;
`

const BigPhotoBox = styled(PhotoBox)`
    width: 300px;
    height: 300px;
    border-radius: 20px;
    overflow: hidden;
`

const IconBox = styled(TouchableOpacity)`
    border: 1px solid grey;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin: 5px;
`

const IconText = styled(Text)`
    font-size: 10px;
`

const SubmitButton = styled(TouchableOpacity)`
    background-color: #6c387a;
    width: 80%;
    padding: 10px;
    border-radius: 5px;
    align-items: center;
    margin-top: 20px;
`

const ButtonText = styled(Text)`
    color: white;
    font-size: 16px;
    font-weight: 700;
`

export const AddPhoto = () => {
    const [camera, setCamera] = useRecoilState(cameraState)
    const [image, setImage] = useRecoilState(imageState)
    const [selectedCategoryValue, setSelectedCategoryValue] = useRecoilState(selectedCategoryValueState)
    const [selectedCategoryTitle, setSelectedCategoryTitle] = useRecoilState(selectedCategoryTitleState)
    const [categoryPoints, setCategoryPoints] = useRecoilState(categoryPointsState)
    const [categoryIcon, setCategoryIcon] = useRecoilState(categoryIconState)
    const [photoPackage, setPhotoPackage] = useRecoilState(submittedPhotoState)
    const [allPhotos, setAllPhotos] = useRecoilState(allPhotosState)
    const [showModal, setShowModal] = useRecoilState(modalState)

    // Conditions
    const hasImage = image !== null
    const hasCategory = selectedCategoryValue !== null

    const takePhoto = () => {
        setCamera(true)
    }

    const uploadPhoto = async () => {
        let result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.All,
            allowsEditing: true,
            quality: 0.5,
            // Get exif data from photo (date, location, etc)
            // exif: true,
        })

        if (!result.cancelled) {
            setImage(result)
        }
    }

    const submitPhoto = () => {
        setAllPhotos([...allPhotos, photoPackage])
        setImage(null)
        setCategoryIcon(null)
        setSelectedCategoryTitle(null)
        setSelectedCategoryValue(null)
        setCategoryPoints(null)
        setShowModal(false)
    }

    useEffect(() => {
        if (showModal === false) {
            setImage(null)
            setCategoryIcon(null)
            setSelectedCategoryTitle(null)
            setSelectedCategoryValue(null)
            setCategoryPoints(null)
        }
    }, [showModal])

    const categories = [
        { title: 'House Overall', icon: 'home', value: 'house-overall', points: 10 },
        { title: 'Fire Damage', icon: 'fire', value: 'fire-damage', points: 5 },
        { title: 'Flood Damage', icon: 'home-flood', value: 'flood-damage', points: 5 },
        { title: 'Window Damage', icon: 'window-closed-variant', value: 'window-damage', points: 5 },
        { title: 'Roof Damage', icon: 'home-roof', value: 'roof-damage', points: 5 },
        { title: 'Hoarding', icon: 'trash-can-outline', value: 'hoarding', points: 5 },
        { title: 'Unkept Landscaping', icon: 'pine-tree', value: 'unkept-landscaping', points: 5 },
        { title: 'Abandoned Car', icon: 'car', value: 'abandoned-car', points: 5 },
        { title: 'Govt. Notice', icon: 'certificate', value: 'govt-notice', points: 5 },
    ]

    return (
        <AddPhotoContainer>
            <Heading>{image ? '' : 'Add a photo'}</Heading>
            {image ? (
                <BigPhotoBox>
                    <ImageBackground source={image} resizeMode="" style={{ width: '100%', height: '100%' }} />
                </BigPhotoBox>
            ) : (
                <Row style={{ flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
                    <PhotoBox onPress={uploadPhoto}>
                        <MaterialCommunityIcons name={'image'} size={48} color={'#6c387a'} iconStyle={{ marginRight: 15 }} />
                    </PhotoBox>
                    <Text>- OR -</Text>
                    <PhotoBox onPress={takePhoto}>
                        <MaterialCommunityIcons name={'camera'} size={48} color={'#6c387a'} iconStyle={{ marginRight: 15 }} />
                    </PhotoBox>
                </Row>
            )}
            {hasImage && (
                <>
                    <Heading>What is this picture of?</Heading>
                    <Text>{selectedCategoryTitle}</Text>
                    <View>
                        <Row style={{ flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
                            {categories.map((category, index) => (
                                <IconBox
                                    key={index}
                                    value={category.value}
                                    onPress={() => {
                                        setSelectedCategoryTitle(category.title), setSelectedCategoryValue(category.value), setCategoryPoints(category.points), setCategoryIcon(category.icon)
                                    }}
                                    style={{ backgroundColor: selectedCategoryValue === category.value ? '#6c387a' : 'white' }}
                                >
                                    <MaterialCommunityIcons name={category.icon} size={32} color={selectedCategoryValue === category.value ? 'white' : '#6c387a'} iconStyle={{ marginRight: 15 }} />
                                </IconBox>
                            ))}
                        </Row>
                    </View>
                </>
            )}
            {hasImage && hasCategory && (
                <SubmitButton onPress={submitPhoto}>
                    <ButtonText>Add to Submission</ButtonText>
                </SubmitButton>
            )}
        </AddPhotoContainer>
    )
}
